// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"rV","mainContent":"sV","activeSidebar":"tV"};